// extracted by mini-css-extract-plugin
module.exports = {"Loading":"loading_Loading__1t5IF","fade":"loading_fade__3T9Gj"};